import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import {
  AddImeiDetailsApi,
  baseurl,
  customerAddApi,
  GetImeiDetailsApi,
  getProfileApi,
  GetSubUserProfileApi,
  SetLimitCheckApi,
  uploadImageApi,
} from "../Utility/Api";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

const AddCustomerModel = (props) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [images, setImages] = useState("");
  const [images1, setImages1] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [city, SetCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [state, setState] = useState("");
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [validstate, setValidState] = useState(false);
  const [imageMsg, setImageMsg] = useState("");
  const [countrycode, setCountryCode] = useState({});
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetch(
      "https://ip-api.io/api/json?api_key=fabc32c1-943d-43c7-8a13-ea82cd6ac052"
    )
      .then((response) => response.json())
      .then((json) => {
        setCountryCode(json);
      });
  }, []);

  const isDisposableEmail = (email) => {
    const domain = email.split("@")[1];
    return disposableEmailDomains.includes(domain);
  };

  const disposableEmailDomains = [
    "mailinator.com",
    "guerrillamail.com",
    "10minutemail.com",
    "temp-mail.org",
    "yopmail.com",
    "getnada.com",
    "trashmail.com",
    "fakeinbox.com",
    "throwawaymail.com",
    "maildrop.cc",
    "mytemp.email",
    "tempmailo.com",
    "dispostable.com",
    "mintemail.com",
    "airmail.com",
  ];

  const handleImages = (e) => {
    var file = e.target.files[0];

    if (file) {
      const minSizeInBytes = 5000; // 5 KB
      const maxSizeInBytes = 1024 * 1024; // 1 MB

      if (file.size < minSizeInBytes) {
        setImageMsg("Image size is below the minimum allowed size (5 KB)");
        e.target.value = null;
        setTimeout(() => {
          setImageMsg("");
        }, 2000);
        return;
      }

      // Check if the file name contains only one dot before the extension
      const fileName = file.name;
      const lastDotIndex = fileName.lastIndexOf(".");
      const baseName = fileName.substring(0, lastDotIndex);
      const extension = fileName.substring(lastDotIndex + 1);

      // Only allow files with a single dot in the base name
      if (baseName.includes(".")) {
        setImageMsg(
          "File name is not valid. Only one dot is allowed before the extension."
        );
        e.target.value = null;
        setTimeout(() => {
          setImageMsg("");
        }, 2000);

        return;
      }

      let size = file.type.replace("/", ".");
      var blob = file.slice(0, file.size, file.type);
      const newName = new Date().getTime() + size;
      var newFile = new File([blob], newName, { type: file.type });

      UploadImage(newFile);
    }
  };

  const UploadImage = async (newFile) => {
    setLoading(true);
    var formdata = new FormData();
    formdata.append("file", newFile);
    formdata.append("type", "customers-images");

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(uploadImageApi, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setImages(result?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  const handleModalClose = () => {
    props?.prop();
  };

  const handlePhoneChange = (value) => {
    setPhoneNo(value);
    const countryInfo = value && value.match(/^\+(\d+)/);
    const countryCode = countryInfo ? `+${countryInfo[1]}` : "";
  };

  const HandleDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete image",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#c76cff",
      cancelButtonColor: "#efefef",
      confirmButtonText: "Yes, delete it!",
      confirmButtonText: "<span style='color: white;'>Yes, delete it!</span>",
      cancelButtonText: "<span style='color: black;'>cancel!</span>",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      customClass: {
        container: "sweet-alert2-container-zindex",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
          confirmButtonColor: "#c76cff",
          customClass: {
            container: "sweet-alert2-container-zindex",
          },
        }).then(() => {
          setImages("");
        });
      }
    });
  };

  const cancleValues = () => {
    setImages("");
    setEmail("");
    setError("");
    setFirstName("");
    setLastName("");
    setAddress("");
    setState("");
    setCountry("");
    SetCity("");
    setPhoneNo("");
    setZipcode("");
    setValidState(false);
    setMessage("");
  };

  const Validation = () => {
    let error = {};
    let reg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    // let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+*!=])(?=.*\d).{6,}$/;
    // const isValid = /^[0-9]+$/.test(value);
    const regex = /^[A-Za-z ]+$/;

    const isNumeric = /^[0-9]+$/;
    if (email && !reg.test(email)) {
      error.email = "Invalid email.";
    } else if (email && isDisposableEmail(email)) {
      error.email =
        "Please use a valid email address. Temporary email addresses are not allowed.";
    }
    if (!firstName) {
      error.firstName = "First Name Is Required";
    } else if (!regex.test(firstName)) {
      error.firstName = "First Name Is Invalid";
    }

    if (Object.keys(error).length === 0) {
      // console.log(Object.keys(error).length);
      CustomerApi();
    }
    return error;
  };

  const CustomerApi = () => {
    document
      .querySelectorAll(".modal-backdrop")
      .forEach((el) => el.classList.remove("modal-backdrop"));
    let local = localStorage.getItem("token");
    let userid = localStorage.getItem("userId");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);
    myHeaders.append(
      "Cookie",
      "connect.sid=s%3AyaHFql-YNXNgdQlka4nRvpWL-iJLSdB-.%2B6wW6d812YXYU4ihAgIwRTFu54mu6VtFKEcdK50W57A"
    );

    var raw = JSON.stringify({
      firstName: firstName,
      lastName: lastName,
      email: email,
      phoneNumber: phoneNo, // phoneNo ? phoneNo.replace(/^\+/, "") : "",
      profileImage: images,
      country: country,
      countryCode: String(countrycode.country_code),
      streetAddress: address,
      state: state,
      zipCode: zipcode,
      city: city,
      mainUserId: userid,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    console.log("raww", raw);
    fetch(customerAddApi, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("result", result);
        if (result.status === true) {
          setShowModal(false);
          props?.prop();
          props?.onBack();
          props?.onCustomerAdd(result?.data);
          //GetCustomer();
          setMessage(result?.message);
          // setFirstName(result?.data?.firstName);
          //  setSelectedCustomer(result?.data?.firstName);
          //  setSelectedCustomerPhone(result?.data?.phoneNumber);
          //  setSelectedCustomerId(result?.data?.id);
          //  setValidState(false);
        } else {
          setMessage(result?.message);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const SubmitCus = () => {
    setError(Validation());
  };

  return (
    <>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addcustomerModalLabel">
              Add New Customer
            </h5>
            <button
              type="button"
              className="close"
              //data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                props?.prop();
                props?.onClose();
                document
                  .querySelectorAll(".modal-backdrop")
                  .forEach((el) => el.classList.remove("modal-backdrop"));
                //handleModalClose();
                cancleValues();
              }}
            >
              <span className="close_icon" />
            </button>
          </div>
          <div className="modal-body">
            <div className="custom_form customer_form">
              <form action="" method="" className="cus_form">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <div className="upload_files">
                        {images ? (
                          <img className="uploaded_img" src={images} alt="" />
                        ) : (
                          <img
                            style={{ display: "none" }}
                            className="uploaded_img"
                            src=""
                            alt=""
                          />
                        )}
                        <div className="file_upload">
                          <input
                            type="file"
                            name="files"
                            accept="image/jpeg, image/jpg, image/png"
                            onChange={handleImages}
                          />
                          <div className="fileedit_icon">
                            <img src="assets/img/file-edit-icon.webp" alt="" />
                          </div>
                        </div>
                        <div className="filetrash_icon deleteimgcust">
                          <a
                            href="#"
                            onClick={() => {
                              if (images) {
                                HandleDelete();
                              }
                            }}
                          >
                            <img src="assets/img/file-trash-icon.webp" alt="" />
                          </a>
                        </div>
                      </div>
                      {imageMsg && (
                        <span className="customvalidationdesignlogin">
                          {imageMsg}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <h5>Credentials</h5>
                  </div>

                  <div className="col-md-6">
                    <div className="form_column col_half">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="first_name"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e) => {
                            setFirstName(e.target.value.trim());
                            if (error.firstName) {
                              setError({ ...error, firstName: "" });
                            }
                          }}
                        />
                        {error.firstName && (
                          <span className="customvalidationdesignlogin">
                            {error.firstName}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 lastnamecust">
                    <div className="form_column col_half">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="last_name"
                          placeholder="Last Name"
                          value={lastName}
                          onChange={(e) => {
                            setLastName(e.target.value.trim());
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form_column col_half">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          placeholder="Email Address"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value.trim());
                            if (error.email) {
                              setError({ ...error, email: "" });
                            }
                          }}
                        />
                        {error.email && (
                          <span className="customvalidationdesignlogin">
                            {error.email}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 lastnamecust">
                    <div className="form_column col_half">
                      <div className="form-group">
                        <PhoneInput
                          className="form-control"
                          placeholder="Enter phone number"
                          international
                          countryCallingCodeEditable={false}
                          //limitMaxLength={10}
                          value={phoneNo}
                          onChange={(val) => {
                            handlePhoneChange(val);
                            // if (error.phoneNo) {
                            //   setError({ ...error, phoneNo: "" });
                            // }
                            setValidState(true);
                          }}
                          //   onKeyup={setValidState(true)}
                          defaultCountry={countrycode.country_code}
                          //defaultCountry="IN"
                          // defaultCountry={country.countryCode}
                          // error={
                          //   value
                          //     ? isValidPhoneNumber(value)
                          //       ? undefined
                          //       : "Invalid phone number"
                          //     : "Phone number required"
                          // }
                        />

                        {/* {error.phoneNo && (
                              <span className="customvalidationdesignlogin">
                                {error.phoneNo}
                              </span>
                            )} */}
                        {validstate === true ? (
                          <span className="customvalidationdesignlogin">
                            {phoneNo && isValidPhoneNumber(phoneNo)
                              ? ""
                              : "Invalid phone number"}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <h5>Address</h5>
                  </div>
                  <div className="col-md-12">
                    <div className="form_column col_full">
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          name="address"
                          placeholder="Street Address"
                          value={address}
                          onChange={(e) => {
                            setAddress(e.target.value);
                          }}
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form_column col_half">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="country"
                          placeholder="Country"
                          value={country}
                          onChange={(e) => {
                            setCountry(e.target.value.trim());
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form_column col_half">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="city"
                          placeholder="City"
                          value={city}
                          onChange={(e) => {
                            SetCity(e.target.value.trim());
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form_column col_half">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="state"
                          placeholder="State / Province"
                          value={state}
                          onChange={(e) => {
                            setState(e.target.value.trim());
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form_column col_half">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="zipcode"
                          placeholder="Zip Code"
                          value={zipcode}
                          onChange={(e) => {
                            setZipcode(e.target.value.trim());
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {message && (
                    <span className="customvalidationdesignlogin">
                      {message}
                    </span>
                  )}
                </div>
              </form>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary default_btn"
              //data-dismiss="modal"
              onClick={() => {
                // handleModalClose();
                cancleValues();
                props?.onBack();
                document
                  .querySelectorAll(".modal-backdrop")
                  .forEach((el) => el.classList.remove("modal-backdrop"));
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary theme_btn"
              onClick={() => SubmitCus()}
            >
              Save Customer
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddCustomerModel;
